module.exports = __webpack_public_path__ + "static/share-91a6c8a2a46127cf234205d02eda50db.png";